import type { PostHogConfig } from 'posthog-js';

export type PostHogRuntimeConfig = {
  apiKey: string | undefined;
  host: string;
};

export function getPostHogConfig(): PostHogRuntimeConfig {
  if (typeof window === 'undefined') {
    return {
      apiKey: process.env.REACT_APP_POSTHOG_KEY,
      host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    };
  }

  const secrets = (window as { REACT_APP_SECRETS?: Record<string, string> }).REACT_APP_SECRETS || {};
  return {
    apiKey: secrets.REACT_APP_POSTHOG_KEY || process.env.REACT_APP_POSTHOG_KEY,
    host: secrets.REACT_APP_POSTHOG_HOST || process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  };
}

export function isPostHogEnabled(): boolean {
  return Boolean(getPostHogConfig().apiKey);
}

/** PostHog init options — see https://posthog.com/docs/libraries/react */
export function getPostHogInitOptions(): Partial<PostHogConfig> {
  return {
    api_host: getPostHogConfig().host,
    defaults: '2026-01-30',
    person_profiles: 'identified_only',
    capture_exceptions: true,
    opt_in_site_apps: true,
  };
}
